import PropTypes from "prop-types";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Drawer } from "antd";
import { Link } from "react-router-dom";

import defaultIcon from "../../assets/icons/sof--png.png";
import { useUser } from "../../contexts/UserContext/UserContext";
import SidebarMenuLinks from "../../components/navigation/SidebarMenuLinks";
import SidebarNavFooter from "../../components/navigation/SidebarNavFooter";

const AppMenuDrawer = ({ open, onClose }) => {
    const { myCompanyData } = useUser();
    const companyLogo =
        myCompanyData?.logo?.light || myCompanyData?.logo?.dark || defaultIcon;
    const companyName = myCompanyData?.name || "Softcar Admin";

    return (
        <Drawer
            placement="left"
            open={open}
            onClose={onClose}
            width={250}
            closable={false}
            styles={{
                body: {
                    padding: 0,
                    background: "#5D5DF6",
                },
                mask: {
                    background: "rgba(47, 47, 70, 0.45)",
                },
            }}
            className="mobile-menu-drawer">
            <div className="flex h-full flex-col rounded-r-[20px] bg-[#5D5DF6] pb-6 pt-5">
                <div className="mb-4 flex items-center justify-between px-4">
                    <Link to="/" onClick={onClose} className="flex min-w-0 flex-1 justify-center">
                        <img
                            src={companyLogo}
                            alt={companyName}
                            className="max-h-10 max-w-[160px] object-contain"
                        />
                    </Link>
                    <Button
                        type="text"
                        aria-label="Close menu"
                        icon={<CloseOutlined className="text-base text-white" />}
                        onClick={onClose}
                        className="!flex !h-9 !w-9 !min-w-9 items-center justify-center !rounded-full hover:!bg-white/10"
                    />
                </div>

                <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
                    <SidebarMenuLinks onNavigate={onClose} />
                </div>

                <div className="mt-4 px-2">
                    <SidebarNavFooter onNavigate={onClose} />
                </div>
            </div>
        </Drawer>
    );
};

AppMenuDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AppMenuDrawer;
